<template>
  <div>
    <!-- List -->
    <div>
      <vs-table
        id="product_list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div @click="toggleAddModal" class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1" @onchange="handleChangePage"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>Period</vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="amount">Amount</vs-th>
          <vs-th sort-key="currency">Currency</vs-th>
          <vs-th sort-key="description">Description</vs-th>
          <vs-th v-if="checkRolesByIds(['admin'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.period || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span class="cursor-pointer" v-if="checkRolesByIds(['admin'])" @click.stop="toggleEditModal(tr)" v-tooltip="{ content: `Edit ${tr.info.item.name}` }"
                >{{ tr.info.item.name || '-' }}
              </span>
              <span v-else>{{ tr.info.item.name || '-' }} </span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.info.item.amount / 100 || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.info.item.currency || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <span>{{ tr.info.item.description || '-' }}</span>
            </vs-td>
            <vs-td v-if="checkRolesByIds(['admin'])">
              <div class="inline-flex">
                <vx-tooltip :text="`${module_name} Edit`">
                  <feather-icon @click.stop="toggleEditModal(tr)" icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <!-- Add modal -->
    <action-modal :module_name="module_name" @update-data="getData" v-if="isAddModalMounted" :showModal.sync="isAddModalShow" :action_name="'Add'" />

    <!-- Edit modal -->
    <action-modal :module_name="module_name" @update-data="getData" v-if="isEditModalMounted" :showModal.sync="isEditModalShow" :data="selectedRecord" :action_name="'Update'" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import actionModal from '@/views/subscription-plan/action'

export default {
  name: 'subscriptionPlanList',

  /** Components */
  components: {
    actionModal
  },

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Subscription Plan',

    // Add modal
    isAddModalMounted: false,
    isAddModalShow: false,

    // Edit modal
    isEditModalMounted: false,
    isEditModalShow: false,
    selectedRecord: null
  }),

  /** computed */
  computed: {
    ...mapState('subscriptionPlan', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkRolesByIds']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('subscriptionPlan', {
      get: 'get',
      delete: 'delete'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** List API */
    getData() {
      this.get({
        // order: this.order,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    // Add modal
    toggleAddModal() {
      this.isAddModalMounted = true
      this.isAddModalShow = true
    },

    // Edit modal
    toggleEditModal(data) {
      this.isEditModalMounted = true
      this.isEditModalShow = true
      this.selectedRecord = data
    },

    /** Delete Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#product_list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#product_list > .con-vs-loading')
      }
    },

    // Add modal
    isAddModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddModalMounted = false
          }, 0)
        }
      }
    },

    // Edit modal
    isEditModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isEditModalMounted = false
          }, 0)
        }
      }
    },

    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
